<template>
  <div class="page">
    <div id="page-header" class="page-header">
      <h2 class="page-header__title">eラーニング受講可能店舗一覧</h2>
    </div>
    <div id="page-content" class="page-content">
      <div v-for="data in shopList" :key="data.title" class="page-content__shop-list">
        <Accordion :content="data"></Accordion>
      </div>
    </div>
    <div id="page-footer" class="page-footer">
      <div class="page-footer__next-button-wrapper">
        <div class="page-footer__next-button-inner">
          <router-link to="/about" custom v-slot="{ navigate }">
            <button id="nextButton" class="btn btn-danger rounded-pill" @click="navigate">
              eラーニングお申込みへ
            </button>
          </router-link>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
    <div id="overlay" v-show="isShowDialog" class="page-content__overlay">
      <div id="content" class="page-content__overlay-contents">
        <article>
          <section>
            <h4 class="page-content__article-section-title--dialog-red-center">
              ≪BSAC Japan eラーニングのお申込みについて≫
            </h4>
            <div class="page-content__article-section-body--dialog-message">
              <p>
                2023年12月25日（月）正午 ～ 2024年1月3日（水）の休業期間中、弊社でeラーニングの受講申込の手続きができなくなります。<br>
                ※お申込みを頂く事はできますが、受講に必要なIDとパスコードの発行処理ができなくなります。<br>
                ご不便をおかけしますが、何卒宜しくお願いいたします。
              </p>
            </div>
          </section>
        </article>
        <div class="page-footer__next-button-wrapper">
          <p><button class="btn btn-danger rounded-pill" @click="closeDialog">閉じる</button></p>
        </div>
      </div>
    </div>
    <!-- モーダルダイアログ -->
  </div>
</template>

<script>
import Accordion from 'vues/common/components/parts/Accordion';

export default {
  /**
   * 本画面に遷移する前に実行する
   * @param {*} to 
   * @param {*} from 
   * @param {*} next 
   */
  beforeRouteEnter(to, from, next) {
    if (from.path === '/') {
      next(function (vm) {
        next(vm => vm.showDialog())
      });
    } else {
      next();
    }
  },
  components: {
    Accordion,
  },
  computed: {
    shopList: function () {
      return this.$store.getters['shop/shopListByRegion'];
    },
  },
  async created() {
    // データの初期化処理はrouter.jsで行う
  },
  data() {
    return {
      isShowDialog: false
    };
  },
  methods: {
    /**
     * ダイアログを開く
     */
     showDialog: function () {
      this.isShowDialog = (new Date().toLocaleDateString('sv-SE') < '2024-01-04');
    },
    /**
     * ダイアログを閉じる
     */
    closeDialog: function () {
      this.isShowDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'stylesheets/page.scss';
</style>
